import { Provider } from '@angular/core';

import { EventTypesProvider } from '../Domain/Port/eventTypesProvider';
import { BackendEventTypesProvider } from '../Infrastructure/Adapter/Backend/backend-events-provider.service';

export const provideEventTypes = (): Provider[] => {
    return [
        {
            provide: EventTypesProvider,
            useClass: BackendEventTypesProvider
        }
    ];
};
